import React from "react";
import Section from "./Section";
import { useTranslation } from "react-i18next";
import SEO from "./SEO";
import PdfViewer from "./PdfViewer";

const TNC: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title={t("seo.pages.terms.title")}
        description={t("seo.pages.terms.description")}
        keywords={t("seo.pages.terms.keywords")}
        canonical="https://deepsoulai.com/tnc"
      />
      <Section title={t("tnc.title")} maxW="1400px">
        <PdfViewer
          title={t("tnc.title")}
          zhUrl="https://appconfig.deepsoulai.com/tnc_tc_v1_5.pdf"
          enUrl="https://appconfig.deepsoulai.com/tnc_en_v1_5.pdf"
          zhCNUrl="https://appconfig.deepsoulai.com/tnc_sc_v1_5.pdf"
        />
      </Section>
    </>
  );
};

export default TNC;
